// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import { assetsAssetIdCustomAttributesDefinitionIdPutResponseTransformer, assetsAssetIdIpAddressesGetResponseTransformer, assetsAssetIdMacAddressesGetResponseTransformer, assetsAssetIdProcessesGetResponseTransformer, assetsAssetIdProcessesProcessGetResponseTransformer, assetsAssetIdStatePatchResponseTransformer, assetsCommunicationsDaysByAssetGetResponseTransformer, assetsCommunicationsGapsGetResponseTransformer, assetsCommunicationsGetResponseTransformer, assetsCommunicationsHourlyByAssetGetResponseTransformer, assetsCommunicationsHourlyByIpGetResponseTransformer, assetsCommunicationsHourlyByTupleGetResponseTransformer, assetsConnectionsGetResponseTransformer, assetsFindingsGetResponseTransformer, assetsGetResponseTransformer, assetsIdGetResponseTransformer, assetsIdPatchResponseTransformer, assetsNetworkActivityPostResponseTransformer, assetsProcessesGetResponseTransformer, assetsProcessTreeGetResponseTransformer, assetsQuerySetsGetResponseTransformer, assetsQuerySetsPostResponseTransformer, assetsQuerySetsPutResponseTransformer, assetsServicesGetResponseTransformer, assetsServicesGroupedGetResponseTransformer, buildingsGetResponseTransformer, buildingsIdGetResponseTransformer, buildingsPostResponseTransformer, buildingsPutResponseTransformer, customAssetAttributesGetResponseTransformer, customAssetAttributesPostResponseTransformer, customAssetAttributesPutResponseTransformer, endpointSensorsGetResponseTransformer, endpointSensorsIdGetResponseTransformer, endpointSensorsPutResponseTransformer, findingHistoryGetResponseTransformer, findingsGetResponseTransformer, findingsIdGetResponseTransformer, galvanickAppliancesGetResponseTransformer, galvanickAppliancesIdGetResponseTransformer, galvanickAppliancesPostResponseTransformer, galvanickAppliancesPutResponseTransformer, huntReportsGetResponseTransformer, idsEventsGetResponseTransformer, idsEventsGroupedCategoriesGetResponseTransformer, idsEventsGroupedRulesGetResponseTransformer, idsEventsIdGetResponseTransformer, ipEnrichmentGetResponseTransformer, ipEnrichmentHistoryGetResponseTransformer, networkPrefixesGetResponseTransformer, networkPrefixesIdGetResponseTransformer, networkPrefixesPostResponseTransformer, networkPrefixesPutResponseTransformer, rollupsAffectedAssetsByDayGetResponseTransformer, rollupsAssetsByDayGetResponseTransformer, rollupsDashboardGetResponseTransformer, rollupsDataTransferByDayGetResponseTransformer, suppressionsGetResponseTransformer, suppressionsUpsertResponseTransformer, ticketsCommentGetResponseTransformer, ticketsCommentPostResponseTransformer, ticketsHistoryPostResponseTransformer, usersEnabledPutResponseTransformer, usersEventsGetResponseTransformer, usersIdCredentialsGetResponseTransformer, usersIdEventsGetResponseTransformer, usersIdGetResponseTransformer, usersIdPatchResponseTransformer, usersOrganizationsIdGetResponseTransformer, usersPostResponseTransformer, vlansGetResponseTransformer, vlansIdGetResponseTransformer, vlansPostResponseTransformer, vlansPutResponseTransformer, vrfsGetResponseTransformer, vrfsIdGetResponseTransformer, vrfsPostResponseTransformer, vrfsPutResponseTransformer } from './transformers.gen';
import type { AafhDeleteData, AafhDeleteErrors, AafhDeleteResponses, AafhGetData, AafhGetErrors, AafhGetResponses, AafhPostData, AafhPostErrors, AafhPostResponses, AdsGetData, AdsGetErrors, AdsGetResponses, AdsIdGetData, AdsIdGetErrors, AdsIdGetResponses, AssetsAssetIdCustomAttributesDefinitionIdPutData, AssetsAssetIdCustomAttributesDefinitionIdPutErrors, AssetsAssetIdCustomAttributesDefinitionIdPutResponses, AssetsAssetIdIpAddressesGetData, AssetsAssetIdIpAddressesGetErrors, AssetsAssetIdIpAddressesGetResponses, AssetsAssetIdMacAddressesGetData, AssetsAssetIdMacAddressesGetErrors, AssetsAssetIdMacAddressesGetResponses, AssetsAssetIdProcessesGetData, AssetsAssetIdProcessesGetErrors, AssetsAssetIdProcessesGetResponses, AssetsAssetIdProcessesProcessGetData, AssetsAssetIdProcessesProcessGetErrors, AssetsAssetIdProcessesProcessGetResponses, AssetsAssetIdStatePatchData, AssetsAssetIdStatePatchErrors, AssetsAssetIdStatePatchResponses, AssetsCommunicationsDaysByAssetGetData, AssetsCommunicationsDaysByAssetGetErrors, AssetsCommunicationsDaysByAssetGetResponses, AssetsCommunicationsGapsGetData, AssetsCommunicationsGapsGetErrors, AssetsCommunicationsGapsGetResponses, AssetsCommunicationsGetData, AssetsCommunicationsGetErrors, AssetsCommunicationsGetResponses, AssetsCommunicationsHourlyByAssetGetData, AssetsCommunicationsHourlyByAssetGetErrors, AssetsCommunicationsHourlyByAssetGetResponses, AssetsCommunicationsHourlyByIpGetData, AssetsCommunicationsHourlyByIpGetErrors, AssetsCommunicationsHourlyByIpGetResponses, AssetsCommunicationsHourlyByTupleGetData, AssetsCommunicationsHourlyByTupleGetErrors, AssetsCommunicationsHourlyByTupleGetResponses, AssetsConnectionsGetData, AssetsConnectionsGetErrors, AssetsConnectionsGetResponses, AssetsDistinctValuesGetData, AssetsDistinctValuesGetErrors, AssetsDistinctValuesGetResponses, AssetsFindingsGetData, AssetsFindingsGetErrors, AssetsFindingsGetResponses, AssetsGetData, AssetsGetErrors, AssetsGetResponses, AssetsIdGetData, AssetsIdGetErrors, AssetsIdGetResponses, AssetsIdPatchData, AssetsIdPatchErrors, AssetsIdPatchResponses, AssetsIdsGetData, AssetsIdsGetErrors, AssetsIdsGetResponses, AssetsNetworkActivityPostData, AssetsNetworkActivityPostErrors, AssetsNetworkActivityPostResponses, AssetsProcessesGetData, AssetsProcessesGetErrors, AssetsProcessesGetResponses, AssetsProcessTreeGetData, AssetsProcessTreeGetErrors, AssetsProcessTreeGetResponses, AssetsQuerySetsDeleteData, AssetsQuerySetsDeleteErrors, AssetsQuerySetsDeleteResponses, AssetsQuerySetsGetData, AssetsQuerySetsGetErrors, AssetsQuerySetsGetResponses, AssetsQuerySetsPostData, AssetsQuerySetsPostErrors, AssetsQuerySetsPostResponses, AssetsQuerySetsPutData, AssetsQuerySetsPutErrors, AssetsQuerySetsPutResponses, AssetsServicesGetData, AssetsServicesGetErrors, AssetsServicesGetResponses, AssetsServicesGroupedGetData, AssetsServicesGroupedGetErrors, AssetsServicesGroupedGetResponses, AssetsTagsDeleteData, AssetsTagsDeleteErrors, AssetsTagsDeleteResponses, AssetsTagsGetData, AssetsTagsGetErrors, AssetsTagsGetResponses, AssetsTagsPostData, AssetsTagsPostErrors, AssetsTagsPostResponses, AssetsTagsPutData, AssetsTagsPutErrors, AssetsTagsPutResponses, AssetsTagsTypesDeleteData, AssetsTagsTypesDeleteErrors, AssetsTagsTypesDeleteResponses, AssetsTagsTypesGetData, AssetsTagsTypesGetErrors, AssetsTagsTypesGetResponses, AssetsTagsTypesPostData, AssetsTagsTypesPostErrors, AssetsTagsTypesPostResponses, AssetsTagsTypesPutData, AssetsTagsTypesPutErrors, AssetsTagsTypesPutResponses, AssetsToTagsPostData, AssetsToTagsPostErrors, AssetsToTagsPostResponses, AssetsToTagsPutData, AssetsToTagsPutErrors, AssetsToTagsPutResponses, BuildingsGetData, BuildingsGetErrors, BuildingsGetResponses, BuildingsIdGetData, BuildingsIdGetErrors, BuildingsIdGetResponses, BuildingsPostData, BuildingsPostErrors, BuildingsPostResponses, BuildingsPutData, BuildingsPutErrors, BuildingsPutResponses, ClosureCategoriesGetData, ClosureCategoriesGetErrors, ClosureCategoriesGetResponses, ClosureCategoriesIdGetData, ClosureCategoriesIdGetErrors, ClosureCategoriesIdGetResponses, ClosureCodesGetData, ClosureCodesGetErrors, ClosureCodesGetResponses, ClosureCodesIdGetData, ClosureCodesIdGetErrors, ClosureCodesIdGetResponses, ContactPostData, ContactPostResponses, CustomAssetAttributesDeleteData, CustomAssetAttributesDeleteErrors, CustomAssetAttributesDeleteResponses, CustomAssetAttributesGetData, CustomAssetAttributesGetErrors, CustomAssetAttributesGetResponses, CustomAssetAttributesPostData, CustomAssetAttributesPostErrors, CustomAssetAttributesPostResponses, CustomAssetAttributesPutData, CustomAssetAttributesPutErrors, CustomAssetAttributesPutResponses, EndpointLogSourcesGetData, EndpointLogSourcesGetErrors, EndpointLogSourcesGetResponses, EndpointLogSourcesPutData, EndpointLogSourcesPutErrors, EndpointLogSourcesPutResponses, EndpointSensorsGetData, EndpointSensorsGetErrors, EndpointSensorsGetResponses, EndpointSensorsIdGetData, EndpointSensorsIdGetErrors, EndpointSensorsIdGetResponses, EndpointSensorsPutData, EndpointSensorsPutErrors, EndpointSensorsPutResponses, FindingHistoryGetData, FindingHistoryGetErrors, FindingHistoryGetResponses, FindingsGetData, FindingsGetErrors, FindingsGetResponses, FindingsIdGetData, FindingsIdGetErrors, FindingsIdGetResponses, GalvanickAppliancesGetData, GalvanickAppliancesGetErrors, GalvanickAppliancesGetResponses, GalvanickAppliancesIdGetData, GalvanickAppliancesIdGetErrors, GalvanickAppliancesIdGetResponses, GalvanickAppliancesLocalPrefixesDeleteData, GalvanickAppliancesLocalPrefixesDeleteErrors, GalvanickAppliancesLocalPrefixesDeleteResponses, GalvanickAppliancesLocalPrefixesPostData, GalvanickAppliancesLocalPrefixesPostErrors, GalvanickAppliancesLocalPrefixesPostResponses, GalvanickAppliancesPostData, GalvanickAppliancesPostErrors, GalvanickAppliancesPostResponses, GalvanickAppliancesPutData, GalvanickAppliancesPutErrors, GalvanickAppliancesPutResponses, GeminiGetData, GeminiGetErrors, GeminiGetResponses, GeminiPostData, GeminiPostErrors, GeminiPostResponses, HuntReportsFileNameGetData, HuntReportsFileNameGetErrors, HuntReportsFileNameGetResponses, HuntReportsGetData, HuntReportsGetErrors, HuntReportsGetResponses, IdsEventsGetData, IdsEventsGetErrors, IdsEventsGetResponses, IdsEventsGroupedCategoriesGetData, IdsEventsGroupedCategoriesGetErrors, IdsEventsGroupedCategoriesGetResponses, IdsEventsGroupedRulesGetData, IdsEventsGroupedRulesGetErrors, IdsEventsGroupedRulesGetResponses, IdsEventsIdGetData, IdsEventsIdGetErrors, IdsEventsIdGetResponses, IpEnrichmentGetData, IpEnrichmentGetErrors, IpEnrichmentGetResponses, IpEnrichmentHistoryGetData, IpEnrichmentHistoryGetErrors, IpEnrichmentHistoryGetResponses, NetworkPrefixesGetData, NetworkPrefixesGetErrors, NetworkPrefixesGetResponses, NetworkPrefixesIdGetData, NetworkPrefixesIdGetErrors, NetworkPrefixesIdGetResponses, NetworkPrefixesPostData, NetworkPrefixesPostErrors, NetworkPrefixesPostResponses, NetworkPrefixesPutData, NetworkPrefixesPutErrors, NetworkPrefixesPutResponses, NetworkPrefixesToTagsDeleteData, NetworkPrefixesToTagsDeleteErrors, NetworkPrefixesToTagsDeleteResponses, NetworkPrefixesToTagsGetData, NetworkPrefixesToTagsGetErrors, NetworkPrefixesToTagsGetResponses, NetworkPrefixesToTagsPostData, NetworkPrefixesToTagsPostErrors, NetworkPrefixesToTagsPostResponses, PcapUploadsPresignPostData, PcapUploadsPresignPostErrors, PcapUploadsPresignPostResponses, PcapUploadsProcessPostData, PcapUploadsProcessPostErrors, PcapUploadsProcessPostResponses, ReportsFindingsGetData, ReportsFindingsGetErrors, ReportsFindingsGetResponses, ReportsFindingsPostData, ReportsFindingsPostErrors, ReportsFindingsPostResponses, ReportsGetData, ReportsGetErrors, ReportsGetResponses, RollupsAffectedAssetsByDayGetData, RollupsAffectedAssetsByDayGetErrors, RollupsAffectedAssetsByDayGetResponses, RollupsAssetsByDayGetData, RollupsAssetsByDayGetErrors, RollupsAssetsByDayGetResponses, RollupsDashboardGetData, RollupsDashboardGetErrors, RollupsDashboardGetResponses, RollupsDataTransferByDayGetData, RollupsDataTransferByDayGetErrors, RollupsDataTransferByDayGetResponses, SensorsGetData, SensorsGetResponses, SuppressionsGetData, SuppressionsGetErrors, SuppressionsGetResponses, SuppressionsUpsertData, SuppressionsUpsertErrors, SuppressionsUpsertResponses, TicketsCommentGetData, TicketsCommentGetErrors, TicketsCommentGetResponses, TicketsCommentPostData, TicketsCommentPostErrors, TicketsCommentPostResponses, TicketsHistoryPostData, TicketsHistoryPostErrors, TicketsHistoryPostResponses, TicketStatusChangesGetData, TicketStatusChangesGetErrors, TicketStatusChangesGetResponses, UsersEnabledPutData, UsersEnabledPutErrors, UsersEnabledPutResponses, UsersEventsGetData, UsersEventsGetErrors, UsersEventsGetResponses, UsersEventTypesGetData, UsersEventTypesGetErrors, UsersEventTypesGetResponses, UsersGetData, UsersGetErrors, UsersGetResponses, UsersGroupDeleteData, UsersGroupDeleteErrors, UsersGroupDeleteResponses, UsersGroupPutData, UsersGroupPutErrors, UsersGroupPutResponses, UsersGroupsGetData, UsersGroupsGetErrors, UsersGroupsGetResponses, UsersIdCredentialsGetData, UsersIdCredentialsGetErrors, UsersIdCredentialsGetResponses, UsersIdEventsGetData, UsersIdEventsGetErrors, UsersIdEventsGetResponses, UsersIdGetData, UsersIdGetErrors, UsersIdGetResponses, UsersIdMfaDeleteData, UsersIdMfaDeleteErrors, UsersIdMfaDeleteResponses, UsersIdPatchData, UsersIdPatchErrors, UsersIdPatchResponses, UsersOrganizationsGetData, UsersOrganizationsGetErrors, UsersOrganizationsGetResponses, UsersOrganizationsIdGetData, UsersOrganizationsIdGetErrors, UsersOrganizationsIdGetResponses, UsersPasswordPostData, UsersPasswordPostErrors, UsersPasswordPostResponses, UsersPostData, UsersPostErrors, UsersPostResponses, ValuesGetData, ValuesGetResponses, VlansGetData, VlansGetErrors, VlansGetResponses, VlansIdGetData, VlansIdGetErrors, VlansIdGetResponses, VlansPostData, VlansPostErrors, VlansPostResponses, VlansPutData, VlansPutErrors, VlansPutResponses, VrfsGetData, VrfsGetErrors, VrfsGetResponses, VrfsIdGetData, VrfsIdGetErrors, VrfsIdGetResponses, VrfsPostData, VrfsPostErrors, VrfsPostResponses, VrfsPutData, VrfsPutErrors, VrfsPutResponses, VrfsToTagsDeleteData, VrfsToTagsDeleteErrors, VrfsToTagsDeleteResponses, VrfsToTagsGetData, VrfsToTagsGetErrors, VrfsToTagsGetResponses, VrfsToTagsPostData, VrfsToTagsPostErrors, VrfsToTagsPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * AAFH - Unlink an asset from a finding
 *
 * Removes an asset from a finding's impacted assets, however it was linked.
 * Succeeds when the asset was not linked.
 *
 */
export const aafhDelete = <ThrowOnError extends boolean = true>(options: Options<AafhDeleteData, ThrowOnError>): RequestResult<AafhDeleteResponses, AafhDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<AafhDeleteResponses, AafhDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aafh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * AAFH - Get list
 */
export const aafhGet = <ThrowOnError extends boolean = true>(options?: Options<AafhGetData, ThrowOnError>): RequestResult<AafhGetResponses, AafhGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AafhGetResponses, AafhGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aafh',
    ...options
});

/**
 * AAFH - Link an asset to a finding
 *
 * Marks an asset as impacted by a finding, for when the detection could not
 * identify it. Linking an asset that is already linked returns the existing link.
 *
 */
export const aafhPost = <ThrowOnError extends boolean = true>(options: Options<AafhPostData, ThrowOnError>): RequestResult<AafhPostResponses, AafhPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AafhPostResponses, AafhPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aafh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * ADS - Get list
 */
export const adsGet = <ThrowOnError extends boolean = true>(options?: Options<AdsGetData, ThrowOnError>): RequestResult<AdsGetResponses, AdsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AdsGetResponses, AdsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ads',
    ...options
});

/**
 * ADS - Get single
 */
export const adsIdGet = <ThrowOnError extends boolean = true>(options: Options<AdsIdGetData, ThrowOnError>): RequestResult<AdsIdGetResponses, AdsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AdsIdGetResponses, AdsIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ads/{id}',
    ...options
});

/**
 * Assets - distinct values for a column
 */
export const assetsDistinctValuesGet = <ThrowOnError extends boolean = true>(options: Options<AssetsDistinctValuesGetData, ThrowOnError>): RequestResult<AssetsDistinctValuesGetResponses, AssetsDistinctValuesGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsDistinctValuesGetResponses, AssetsDistinctValuesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/distinct-values',
    ...options
});

/**
 * Assets - Get list of IDs
 */
export const assetsIdsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsIdsGetData, ThrowOnError>): RequestResult<AssetsIdsGetResponses, AssetsIdsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsIdsGetResponses, AssetsIdsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/ids',
    ...options
});

/**
 * Assets - Get list
 */
export const assetsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsGetData, ThrowOnError>): RequestResult<AssetsGetResponses, AssetsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsGetResponses, AssetsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets',
    ...options
});

/**
 * Assets - Get list with findings filters
 */
export const assetsFindingsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsFindingsGetData, ThrowOnError>): RequestResult<AssetsFindingsGetResponses, AssetsFindingsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsFindingsGetResponses, AssetsFindingsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsFindingsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/findings',
    ...options
});

/**
 * Assets - Get single
 */
export const assetsIdGet = <ThrowOnError extends boolean = true>(options: Options<AssetsIdGetData, ThrowOnError>): RequestResult<AssetsIdGetResponses, AssetsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsIdGetResponses, AssetsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{id}',
    ...options
});

/**
 * Patch updates to an asset
 */
export const assetsIdPatch = <ThrowOnError extends boolean = true>(options: Options<AssetsIdPatchData, ThrowOnError>): RequestResult<AssetsIdPatchResponses, AssetsIdPatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<AssetsIdPatchResponses, AssetsIdPatchErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsIdPatchResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Asset state - Set
 *
 * Manually sets an asset's state and records the caller as state_modified_by. DUPLICATE may name the existing asset it duplicates in duplicate_of_asset_id; other states clear it.
 */
export const assetsAssetIdStatePatch = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdStatePatchData, ThrowOnError>): RequestResult<AssetsAssetIdStatePatchResponses, AssetsAssetIdStatePatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<AssetsAssetIdStatePatchResponses, AssetsAssetIdStatePatchErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdStatePatchResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asset's IP addresses - Get list
 */
export const assetsAssetIdIpAddressesGet = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdIpAddressesGetData, ThrowOnError>): RequestResult<AssetsAssetIdIpAddressesGetResponses, AssetsAssetIdIpAddressesGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsAssetIdIpAddressesGetResponses, AssetsAssetIdIpAddressesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdIpAddressesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/ip_addresses',
    ...options
});

/**
 * Asset's IP addresses - Get list
 */
export const assetsAssetIdMacAddressesGet = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdMacAddressesGetData, ThrowOnError>): RequestResult<AssetsAssetIdMacAddressesGetResponses, AssetsAssetIdMacAddressesGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsAssetIdMacAddressesGetResponses, AssetsAssetIdMacAddressesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdMacAddressesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/mac_addresses',
    ...options
});

/**
 * Asset's custom attribute value - Set
 *
 * Sets a single custom attribute value for an asset, or clears it if value is null.
 */
export const assetsAssetIdCustomAttributesDefinitionIdPut = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdCustomAttributesDefinitionIdPutData, ThrowOnError>): RequestResult<AssetsAssetIdCustomAttributesDefinitionIdPutResponses, AssetsAssetIdCustomAttributesDefinitionIdPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<AssetsAssetIdCustomAttributesDefinitionIdPutResponses, AssetsAssetIdCustomAttributesDefinitionIdPutErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdCustomAttributesDefinitionIdPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/custom_attributes/{definition_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asset communications - Get list
 */
export const assetsCommunicationsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsCommunicationsGetData, ThrowOnError>): RequestResult<AssetsCommunicationsGetResponses, AssetsCommunicationsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsCommunicationsGetResponses, AssetsCommunicationsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications',
    ...options
});

/**
 * IP enrichment - Get list
 *
 * Returns geolocation and ASN enrichment for the requested IP addresses. Only IPs present in the enrichment store are returned; callers map results back by ip.
 */
export const ipEnrichmentGet = <ThrowOnError extends boolean = true>(options: Options<IpEnrichmentGetData, ThrowOnError>): RequestResult<IpEnrichmentGetResponses, IpEnrichmentGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<IpEnrichmentGetResponses, IpEnrichmentGetErrors, ThrowOnError, 'data'>({
    responseTransformer: ipEnrichmentGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ip_enrichment',
    ...options
});

/**
 * IP enrichment history - Get list
 *
 * Returns every stored version of the enrichment for the requested IP addresses, oldest first, so callers can diff consecutive versions to find when a field changed.
 */
export const ipEnrichmentHistoryGet = <ThrowOnError extends boolean = true>(options: Options<IpEnrichmentHistoryGetData, ThrowOnError>): RequestResult<IpEnrichmentHistoryGetResponses, IpEnrichmentHistoryGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<IpEnrichmentHistoryGetResponses, IpEnrichmentHistoryGetErrors, ThrowOnError, 'data'>({
    responseTransformer: ipEnrichmentHistoryGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ip_enrichment/history',
    ...options
});

/**
 * Asset communication gaps - Get list
 *
 * Returns time gaps of 5+ minutes between communications for the specified assets within a time range
 */
export const assetsCommunicationsGapsGet = <ThrowOnError extends boolean = true>(options: Options<AssetsCommunicationsGapsGetData, ThrowOnError>): RequestResult<AssetsCommunicationsGapsGetResponses, AssetsCommunicationsGapsGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsCommunicationsGapsGetResponses, AssetsCommunicationsGapsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsGapsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications/gaps',
    ...options
});

/**
 * Asset communications hourly by asset - Get list
 */
export const assetsCommunicationsHourlyByAssetGet = <ThrowOnError extends boolean = true>(options: Options<AssetsCommunicationsHourlyByAssetGetData, ThrowOnError>): RequestResult<AssetsCommunicationsHourlyByAssetGetResponses, AssetsCommunicationsHourlyByAssetGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsCommunicationsHourlyByAssetGetResponses, AssetsCommunicationsHourlyByAssetGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsHourlyByAssetGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications/hourly/by-asset',
    ...options
});

/**
 * Asset communications hourly by IP - Get list
 *
 * Per-hour session/byte totals for a single external peer IP, aggregated across all ports/protocols. Keeps hour_start (unlike by-tuple), giving a time series for the IP-detail popup.
 */
export const assetsCommunicationsHourlyByIpGet = <ThrowOnError extends boolean = true>(options: Options<AssetsCommunicationsHourlyByIpGetData, ThrowOnError>): RequestResult<AssetsCommunicationsHourlyByIpGetResponses, AssetsCommunicationsHourlyByIpGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsCommunicationsHourlyByIpGetResponses, AssetsCommunicationsHourlyByIpGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsHourlyByIpGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications/hourly/by-ip',
    ...options
});

/**
 * Asset communications days by asset - Get list
 *
 * Returns one row per local day the asset communicated, with a coarse connection count, from the hourly rollup. Lightweight fast path for the uptime bar strip.
 */
export const assetsCommunicationsDaysByAssetGet = <ThrowOnError extends boolean = true>(options: Options<AssetsCommunicationsDaysByAssetGetData, ThrowOnError>): RequestResult<AssetsCommunicationsDaysByAssetGetResponses, AssetsCommunicationsDaysByAssetGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsCommunicationsDaysByAssetGetResponses, AssetsCommunicationsDaysByAssetGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsDaysByAssetGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications/days/by-asset',
    ...options
});

/**
 * Asset network activity - Get list
 *
 * Per-asset active-day counts over the last 90 days (from the hourly rollup). Includes all active assets; those with no activity in the window report zero active days. Sortable by most_recent_ip, hostname, type, active_days. POST so the optional asset_ids filter (can be hundreds of IDs) rides in the body instead of overflowing the URL/header size limit.
 */
export const assetsNetworkActivityPost = <ThrowOnError extends boolean = true>(options: Options<AssetsNetworkActivityPostData, ThrowOnError>): RequestResult<AssetsNetworkActivityPostResponses, AssetsNetworkActivityPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AssetsNetworkActivityPostResponses, AssetsNetworkActivityPostErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsNetworkActivityPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/network-activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asset communications hourly by tuple - Get list
 */
export const assetsCommunicationsHourlyByTupleGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsCommunicationsHourlyByTupleGetData, ThrowOnError>): RequestResult<AssetsCommunicationsHourlyByTupleGetResponses, AssetsCommunicationsHourlyByTupleGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsCommunicationsHourlyByTupleGetResponses, AssetsCommunicationsHourlyByTupleGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsCommunicationsHourlyByTupleGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/communications/hourly/by-tuple',
    ...options
});

/**
 * Asset connections - Get list
 */
export const assetsConnectionsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsConnectionsGetData, ThrowOnError>): RequestResult<AssetsConnectionsGetResponses, AssetsConnectionsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsConnectionsGetResponses, AssetsConnectionsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsConnectionsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/connections',
    ...options
});

/**
 * Asset process tree - Get full tree
 */
export const assetsProcessTreeGet = <ThrowOnError extends boolean = true>(options: Options<AssetsProcessTreeGetData, ThrowOnError>): RequestResult<AssetsProcessTreeGetResponses, AssetsProcessTreeGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsProcessTreeGetResponses, AssetsProcessTreeGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsProcessTreeGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/process-tree',
    ...options
});

/**
 * Asset processes - Get list of executions across assets
 */
export const assetsProcessesGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsProcessesGetData, ThrowOnError>): RequestResult<AssetsProcessesGetResponses, AssetsProcessesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsProcessesGetResponses, AssetsProcessesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsProcessesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/processes',
    ...options
});

/**
 * Asset processes grouped - Get list for asset
 */
export const assetsAssetIdProcessesGet = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdProcessesGetData, ThrowOnError>): RequestResult<AssetsAssetIdProcessesGetResponses, AssetsAssetIdProcessesGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsAssetIdProcessesGetResponses, AssetsAssetIdProcessesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdProcessesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/processes',
    ...options
});

/**
 * Asset processes - Get list of executions for process on asset
 */
export const assetsAssetIdProcessesProcessGet = <ThrowOnError extends boolean = true>(options: Options<AssetsAssetIdProcessesProcessGetData, ThrowOnError>): RequestResult<AssetsAssetIdProcessesProcessGetResponses, AssetsAssetIdProcessesProcessGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<AssetsAssetIdProcessesProcessGetResponses, AssetsAssetIdProcessesProcessGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsAssetIdProcessesProcessGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/{asset_id}/processes/{process}',
    ...options
});

/**
 * Saved queries for assets - Delete
 */
export const assetsQuerySetsDelete = <ThrowOnError extends boolean = true>(options?: Options<AssetsQuerySetsDeleteData, ThrowOnError>): RequestResult<AssetsQuerySetsDeleteResponses, AssetsQuerySetsDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<AssetsQuerySetsDeleteResponses, AssetsQuerySetsDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/query-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Saved queries for assets - Get list
 */
export const assetsQuerySetsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsQuerySetsGetData, ThrowOnError>): RequestResult<AssetsQuerySetsGetResponses, AssetsQuerySetsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsQuerySetsGetResponses, AssetsQuerySetsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsQuerySetsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/query-sets',
    ...options
});

/**
 * Saved queries for asset - Create new
 */
export const assetsQuerySetsPost = <ThrowOnError extends boolean = true>(options?: Options<AssetsQuerySetsPostData, ThrowOnError>): RequestResult<AssetsQuerySetsPostResponses, AssetsQuerySetsPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<AssetsQuerySetsPostResponses, AssetsQuerySetsPostErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsQuerySetsPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/query-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Saved queries for assets - Update existing
 */
export const assetsQuerySetsPut = <ThrowOnError extends boolean = true>(options?: Options<AssetsQuerySetsPutData, ThrowOnError>): RequestResult<AssetsQuerySetsPutResponses, AssetsQuerySetsPutErrors, ThrowOnError, 'data'> => (options?.client ?? client).put<AssetsQuerySetsPutResponses, AssetsQuerySetsPutErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsQuerySetsPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/query-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset services - Get list
 */
export const assetsServicesGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsServicesGetData, ThrowOnError>): RequestResult<AssetsServicesGetResponses, AssetsServicesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsServicesGetResponses, AssetsServicesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsServicesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/services',
    ...options
});

/**
 * Asset services grouped - Get list
 */
export const assetsServicesGroupedGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsServicesGroupedGetData, ThrowOnError>): RequestResult<AssetsServicesGroupedGetResponses, AssetsServicesGroupedGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsServicesGroupedGetResponses, AssetsServicesGroupedGetErrors, ThrowOnError, 'data'>({
    responseTransformer: assetsServicesGroupedGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/services/grouped',
    ...options
});

/**
 * Asset-tag relationship - Create new
 */
export const assetsToTagsPost = <ThrowOnError extends boolean = true>(options?: Options<AssetsToTagsPostData, ThrowOnError>): RequestResult<AssetsToTagsPostResponses, AssetsToTagsPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<AssetsToTagsPostResponses, AssetsToTagsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset-tag relationship - Update (used to suppress a tag)
 *
 * Removing a tag from an asset is a soft-suppress rather than a delete: set state to 'SUPPRESSED' and last_modified_by to the acting user. This keeps a user's removal durable so Fixer's auto-tagging will not re-apply it.
 */
export const assetsToTagsPut = <ThrowOnError extends boolean = true>(options?: Options<AssetsToTagsPutData, ThrowOnError>): RequestResult<AssetsToTagsPutResponses, AssetsToTagsPutErrors, ThrowOnError, 'data'> => (options?.client ?? client).put<AssetsToTagsPutResponses, AssetsToTagsPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tag - Delete
 */
export const assetsTagsDelete = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsDeleteData, ThrowOnError>): RequestResult<AssetsTagsDeleteResponses, AssetsTagsDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<AssetsTagsDeleteResponses, AssetsTagsDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tags - Get list
 */
export const assetsTagsGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsGetData, ThrowOnError>): RequestResult<AssetsTagsGetResponses, AssetsTagsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsTagsGetResponses, AssetsTagsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags',
    ...options
});

/**
 * Asset tags - Create new
 */
export const assetsTagsPost = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsPostData, ThrowOnError>): RequestResult<AssetsTagsPostResponses, AssetsTagsPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<AssetsTagsPostResponses, AssetsTagsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tags - Update existing
 */
export const assetsTagsPut = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsPutData, ThrowOnError>): RequestResult<AssetsTagsPutResponses, AssetsTagsPutErrors, ThrowOnError, 'data'> => (options?.client ?? client).put<AssetsTagsPutResponses, AssetsTagsPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tag type - Delete
 */
export const assetsTagsTypesDelete = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsTypesDeleteData, ThrowOnError>): RequestResult<AssetsTagsTypesDeleteResponses, AssetsTagsTypesDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<AssetsTagsTypesDeleteResponses, AssetsTagsTypesDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags/types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tag types - Get list
 */
export const assetsTagsTypesGet = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsTypesGetData, ThrowOnError>): RequestResult<AssetsTagsTypesGetResponses, AssetsTagsTypesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<AssetsTagsTypesGetResponses, AssetsTagsTypesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags/types',
    ...options
});

/**
 * Asset tag types - Create new
 */
export const assetsTagsTypesPost = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsTypesPostData, ThrowOnError>): RequestResult<AssetsTagsTypesPostResponses, AssetsTagsTypesPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<AssetsTagsTypesPostResponses, AssetsTagsTypesPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags/types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Asset tag types - Update existing
 */
export const assetsTagsTypesPut = <ThrowOnError extends boolean = true>(options?: Options<AssetsTagsTypesPutData, ThrowOnError>): RequestResult<AssetsTagsTypesPutResponses, AssetsTagsTypesPutErrors, ThrowOnError, 'data'> => (options?.client ?? client).put<AssetsTagsTypesPutResponses, AssetsTagsTypesPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assets/tags/types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Closure categories - Get list
 */
export const closureCategoriesGet = <ThrowOnError extends boolean = true>(options?: Options<ClosureCategoriesGetData, ThrowOnError>): RequestResult<ClosureCategoriesGetResponses, ClosureCategoriesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ClosureCategoriesGetResponses, ClosureCategoriesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/closure_categories',
    ...options
});

/**
 * Closure categories - Get single
 */
export const closureCategoriesIdGet = <ThrowOnError extends boolean = true>(options: Options<ClosureCategoriesIdGetData, ThrowOnError>): RequestResult<ClosureCategoriesIdGetResponses, ClosureCategoriesIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<ClosureCategoriesIdGetResponses, ClosureCategoriesIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/closure_categories/{id}',
    ...options
});

/**
 * Closure codes - Get list
 */
export const closureCodesGet = <ThrowOnError extends boolean = true>(options?: Options<ClosureCodesGetData, ThrowOnError>): RequestResult<ClosureCodesGetResponses, ClosureCodesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ClosureCodesGetResponses, ClosureCodesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/closure_codes',
    ...options
});

/**
 * Closure codes - Get single
 */
export const closureCodesIdGet = <ThrowOnError extends boolean = true>(options: Options<ClosureCodesIdGetData, ThrowOnError>): RequestResult<ClosureCodesIdGetResponses, ClosureCodesIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<ClosureCodesIdGetResponses, ClosureCodesIdGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/closure_codes/{id}',
    ...options
});

/**
 * Contact form - Submit
 */
export const contactPost = <ThrowOnError extends boolean = true>(options?: Options<ContactPostData, ThrowOnError>): RequestResult<ContactPostResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<ContactPostResponses, unknown, ThrowOnError, 'data'>({
    ...formDataBodySerializer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/contact',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Findings - Get list
 */
export const findingsGet = <ThrowOnError extends boolean = true>(options?: Options<FindingsGetData, ThrowOnError>): RequestResult<FindingsGetResponses, FindingsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<FindingsGetResponses, FindingsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: findingsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/findings',
    ...options
});

/**
 * Findings - Get single
 */
export const findingsIdGet = <ThrowOnError extends boolean = true>(options: Options<FindingsIdGetData, ThrowOnError>): RequestResult<FindingsIdGetResponses, FindingsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<FindingsIdGetResponses, FindingsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: findingsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/findings/{id}',
    ...options
});

/**
 * Findings - Get list
 */
export const findingHistoryGet = <ThrowOnError extends boolean = true>(options?: Options<FindingHistoryGetData, ThrowOnError>): RequestResult<FindingHistoryGetResponses, FindingHistoryGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<FindingHistoryGetResponses, FindingHistoryGetErrors, ThrowOnError, 'data'>({
    responseTransformer: findingHistoryGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/finding_history',
    ...options
});

/**
 * Gemini - Get settings
 */
export const geminiGet = <ThrowOnError extends boolean = true>(options?: Options<GeminiGetData, ThrowOnError>): RequestResult<GeminiGetResponses, GeminiGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GeminiGetResponses, GeminiGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/gemini',
    ...options
});

/**
 * Gemini - Post settings
 */
export const geminiPost = <ThrowOnError extends boolean = true>(options: Options<GeminiPostData, ThrowOnError>): RequestResult<GeminiPostResponses, GeminiPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<GeminiPostResponses, GeminiPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/gemini',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hunt reports - Get list of files
 */
export const huntReportsGet = <ThrowOnError extends boolean = true>(options?: Options<HuntReportsGetData, ThrowOnError>): RequestResult<HuntReportsGetResponses, HuntReportsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<HuntReportsGetResponses, HuntReportsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: huntReportsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/hunt_reports',
    ...options
});

/**
 * Hunt reports - Get file
 */
export const huntReportsFileNameGet = <ThrowOnError extends boolean = true>(options: Options<HuntReportsFileNameGetData, ThrowOnError>): RequestResult<HuntReportsFileNameGetResponses, HuntReportsFileNameGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<HuntReportsFileNameGetResponses, HuntReportsFileNameGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/hunt_reports/{file_name}',
    ...options
});

/**
 * IDS events - Get list
 */
export const idsEventsGet = <ThrowOnError extends boolean = true>(options?: Options<IdsEventsGetData, ThrowOnError>): RequestResult<IdsEventsGetResponses, IdsEventsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<IdsEventsGetResponses, IdsEventsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: idsEventsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ids_events',
    ...options
});

/**
 * IDS events - Get list grouped by category
 *
 * One row per Suricata rule category, aggregating every alert matching the filters. The level above a rule: filtering the rule-grouped endpoint by category gives the rules inside one of these rows.
 */
export const idsEventsGroupedCategoriesGet = <ThrowOnError extends boolean = true>(options?: Options<IdsEventsGroupedCategoriesGetData, ThrowOnError>): RequestResult<IdsEventsGroupedCategoriesGetResponses, IdsEventsGroupedCategoriesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<IdsEventsGroupedCategoriesGetResponses, IdsEventsGroupedCategoriesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: idsEventsGroupedCategoriesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ids_events/grouped/categories',
    ...options
});

/**
 * IDS events - Get list grouped by rule
 *
 * One row per Suricata rule, aggregating every alert matching the filters. The filters narrow which alerts are counted, not which rules are returned.
 */
export const idsEventsGroupedRulesGet = <ThrowOnError extends boolean = true>(options?: Options<IdsEventsGroupedRulesGetData, ThrowOnError>): RequestResult<IdsEventsGroupedRulesGetResponses, IdsEventsGroupedRulesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<IdsEventsGroupedRulesGetResponses, IdsEventsGroupedRulesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: idsEventsGroupedRulesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ids_events/grouped/rules',
    ...options
});

/**
 * IDS events - Get single
 */
export const idsEventsIdGet = <ThrowOnError extends boolean = true>(options: Options<IdsEventsIdGetData, ThrowOnError>): RequestResult<IdsEventsIdGetResponses, IdsEventsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<IdsEventsIdGetResponses, IdsEventsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: idsEventsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ids_events/{id}',
    ...options
});

/**
 * Reports - Get list
 */
export const reportsGet = <ThrowOnError extends boolean = true>(options?: Options<ReportsGetData, ThrowOnError>): RequestResult<ReportsGetResponses, ReportsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ReportsGetResponses, ReportsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports',
    ...options
});

/**
 * Findings reports - Get schema
 */
export const reportsFindingsGet = <ThrowOnError extends boolean = true>(options?: Options<ReportsFindingsGetData, ThrowOnError>): RequestResult<ReportsFindingsGetResponses, ReportsFindingsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ReportsFindingsGetResponses, ReportsFindingsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/findings',
    ...options
});

/**
 * Findings reports - Generate
 */
export const reportsFindingsPost = <ThrowOnError extends boolean = true>(options: Options<ReportsFindingsPostData, ThrowOnError>): RequestResult<ReportsFindingsPostResponses, ReportsFindingsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ReportsFindingsPostResponses, ReportsFindingsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/findings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rollupsAffectedAssetsByDayGet = <ThrowOnError extends boolean = true>(options?: Options<RollupsAffectedAssetsByDayGetData, ThrowOnError>): RequestResult<RollupsAffectedAssetsByDayGetResponses, RollupsAffectedAssetsByDayGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<RollupsAffectedAssetsByDayGetResponses, RollupsAffectedAssetsByDayGetErrors, ThrowOnError, 'data'>({
    responseTransformer: rollupsAffectedAssetsByDayGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/rollups/affected-assets-by-day',
    ...options
});

export const rollupsAssetsByDayGet = <ThrowOnError extends boolean = true>(options?: Options<RollupsAssetsByDayGetData, ThrowOnError>): RequestResult<RollupsAssetsByDayGetResponses, RollupsAssetsByDayGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<RollupsAssetsByDayGetResponses, RollupsAssetsByDayGetErrors, ThrowOnError, 'data'>({
    responseTransformer: rollupsAssetsByDayGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/rollups/assets-by-day',
    ...options
});

export const rollupsDashboardGet = <ThrowOnError extends boolean = true>(options?: Options<RollupsDashboardGetData, ThrowOnError>): RequestResult<RollupsDashboardGetResponses, RollupsDashboardGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<RollupsDashboardGetResponses, RollupsDashboardGetErrors, ThrowOnError, 'data'>({
    responseTransformer: rollupsDashboardGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/rollups/dashboard',
    ...options
});

export const rollupsDataTransferByDayGet = <ThrowOnError extends boolean = true>(options?: Options<RollupsDataTransferByDayGetData, ThrowOnError>): RequestResult<RollupsDataTransferByDayGetResponses, RollupsDataTransferByDayGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<RollupsDataTransferByDayGetResponses, RollupsDataTransferByDayGetErrors, ThrowOnError, 'data'>({
    responseTransformer: rollupsDataTransferByDayGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/rollups/data-transfer-by-day',
    ...options
});

/**
 * Sensor inventory listing
 */
export const sensorsGet = <ThrowOnError extends boolean = true>(options?: Options<SensorsGetData, ThrowOnError>): RequestResult<SensorsGetResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<SensorsGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sensors',
    ...options
});

/**
 * VRFs - Get list
 */
export const vrfsGet = <ThrowOnError extends boolean = true>(options?: Options<VrfsGetData, ThrowOnError>): RequestResult<VrfsGetResponses, VrfsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<VrfsGetResponses, VrfsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: vrfsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs',
    ...options
});

/**
 * VRFs - Create
 */
export const vrfsPost = <ThrowOnError extends boolean = true>(options: Options<VrfsPostData, ThrowOnError>): RequestResult<VrfsPostResponses, VrfsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<VrfsPostResponses, VrfsPostErrors, ThrowOnError, 'data'>({
    responseTransformer: vrfsPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * VRFs - Update
 */
export const vrfsPut = <ThrowOnError extends boolean = true>(options: Options<VrfsPutData, ThrowOnError>): RequestResult<VrfsPutResponses, VrfsPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<VrfsPutResponses, VrfsPutErrors, ThrowOnError, 'data'>({
    responseTransformer: vrfsPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * VRF-tag relationship - Delete
 */
export const vrfsToTagsDelete = <ThrowOnError extends boolean = true>(options?: Options<VrfsToTagsDeleteData, ThrowOnError>): RequestResult<VrfsToTagsDeleteResponses, VrfsToTagsDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<VrfsToTagsDeleteResponses, VrfsToTagsDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * VRF-tag relationship - Get list
 */
export const vrfsToTagsGet = <ThrowOnError extends boolean = true>(options?: Options<VrfsToTagsGetData, ThrowOnError>): RequestResult<VrfsToTagsGetResponses, VrfsToTagsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<VrfsToTagsGetResponses, VrfsToTagsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs/to-tags',
    ...options
});

/**
 * VRF-tag relationship - Create new
 */
export const vrfsToTagsPost = <ThrowOnError extends boolean = true>(options?: Options<VrfsToTagsPostData, ThrowOnError>): RequestResult<VrfsToTagsPostResponses, VrfsToTagsPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<VrfsToTagsPostResponses, VrfsToTagsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * VRFs - Get single
 */
export const vrfsIdGet = <ThrowOnError extends boolean = true>(options: Options<VrfsIdGetData, ThrowOnError>): RequestResult<VrfsIdGetResponses, VrfsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<VrfsIdGetResponses, VrfsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: vrfsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vrfs/{id}',
    ...options
});

/**
 * VLANs - Get list
 */
export const vlansGet = <ThrowOnError extends boolean = true>(options?: Options<VlansGetData, ThrowOnError>): RequestResult<VlansGetResponses, VlansGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<VlansGetResponses, VlansGetErrors, ThrowOnError, 'data'>({
    responseTransformer: vlansGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vlans',
    ...options
});

/**
 * VLANs - Create
 */
export const vlansPost = <ThrowOnError extends boolean = true>(options: Options<VlansPostData, ThrowOnError>): RequestResult<VlansPostResponses, VlansPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<VlansPostResponses, VlansPostErrors, ThrowOnError, 'data'>({
    responseTransformer: vlansPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vlans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * VLANs - Update
 */
export const vlansPut = <ThrowOnError extends boolean = true>(options: Options<VlansPutData, ThrowOnError>): RequestResult<VlansPutResponses, VlansPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<VlansPutResponses, VlansPutErrors, ThrowOnError, 'data'>({
    responseTransformer: vlansPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vlans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * VLANs - Get single
 */
export const vlansIdGet = <ThrowOnError extends boolean = true>(options: Options<VlansIdGetData, ThrowOnError>): RequestResult<VlansIdGetResponses, VlansIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<VlansIdGetResponses, VlansIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: vlansIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vlans/{id}',
    ...options
});

/**
 * Network prefixes - Get list
 */
export const networkPrefixesGet = <ThrowOnError extends boolean = true>(options?: Options<NetworkPrefixesGetData, ThrowOnError>): RequestResult<NetworkPrefixesGetResponses, NetworkPrefixesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<NetworkPrefixesGetResponses, NetworkPrefixesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: networkPrefixesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes',
    ...options
});

/**
 * Network prefixes - Create
 */
export const networkPrefixesPost = <ThrowOnError extends boolean = true>(options: Options<NetworkPrefixesPostData, ThrowOnError>): RequestResult<NetworkPrefixesPostResponses, NetworkPrefixesPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<NetworkPrefixesPostResponses, NetworkPrefixesPostErrors, ThrowOnError, 'data'>({
    responseTransformer: networkPrefixesPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Network prefixes - Update
 */
export const networkPrefixesPut = <ThrowOnError extends boolean = true>(options: Options<NetworkPrefixesPutData, ThrowOnError>): RequestResult<NetworkPrefixesPutResponses, NetworkPrefixesPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<NetworkPrefixesPutResponses, NetworkPrefixesPutErrors, ThrowOnError, 'data'>({
    responseTransformer: networkPrefixesPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Network prefix-tag relationship - Delete
 */
export const networkPrefixesToTagsDelete = <ThrowOnError extends boolean = true>(options?: Options<NetworkPrefixesToTagsDeleteData, ThrowOnError>): RequestResult<NetworkPrefixesToTagsDeleteResponses, NetworkPrefixesToTagsDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<NetworkPrefixesToTagsDeleteResponses, NetworkPrefixesToTagsDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Network prefix-tag relationship - Get list
 */
export const networkPrefixesToTagsGet = <ThrowOnError extends boolean = true>(options?: Options<NetworkPrefixesToTagsGetData, ThrowOnError>): RequestResult<NetworkPrefixesToTagsGetResponses, NetworkPrefixesToTagsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<NetworkPrefixesToTagsGetResponses, NetworkPrefixesToTagsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes/to-tags',
    ...options
});

/**
 * Network prefix-tag relationship - Create new
 */
export const networkPrefixesToTagsPost = <ThrowOnError extends boolean = true>(options?: Options<NetworkPrefixesToTagsPostData, ThrowOnError>): RequestResult<NetworkPrefixesToTagsPostResponses, NetworkPrefixesToTagsPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<NetworkPrefixesToTagsPostResponses, NetworkPrefixesToTagsPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes/to-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Network prefixes - Get single
 */
export const networkPrefixesIdGet = <ThrowOnError extends boolean = true>(options: Options<NetworkPrefixesIdGetData, ThrowOnError>): RequestResult<NetworkPrefixesIdGetResponses, NetworkPrefixesIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<NetworkPrefixesIdGetResponses, NetworkPrefixesIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: networkPrefixesIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/network_prefixes/{id}',
    ...options
});

/**
 * Buildings - Get list
 */
export const buildingsGet = <ThrowOnError extends boolean = true>(options?: Options<BuildingsGetData, ThrowOnError>): RequestResult<BuildingsGetResponses, BuildingsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<BuildingsGetResponses, BuildingsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: buildingsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/buildings',
    ...options
});

/**
 * Buildings - Create
 */
export const buildingsPost = <ThrowOnError extends boolean = true>(options: Options<BuildingsPostData, ThrowOnError>): RequestResult<BuildingsPostResponses, BuildingsPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<BuildingsPostResponses, BuildingsPostErrors, ThrowOnError, 'data'>({
    responseTransformer: buildingsPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/buildings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buildings - Update
 */
export const buildingsPut = <ThrowOnError extends boolean = true>(options: Options<BuildingsPutData, ThrowOnError>): RequestResult<BuildingsPutResponses, BuildingsPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<BuildingsPutResponses, BuildingsPutErrors, ThrowOnError, 'data'>({
    responseTransformer: buildingsPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/buildings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Custom asset attribute definitions - Delete
 *
 * Deleting a definition also removes its value from every asset's stored custom attributes.
 */
export const customAssetAttributesDelete = <ThrowOnError extends boolean = true>(options?: Options<CustomAssetAttributesDeleteData, ThrowOnError>): RequestResult<CustomAssetAttributesDeleteResponses, CustomAssetAttributesDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<CustomAssetAttributesDeleteResponses, CustomAssetAttributesDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/custom_asset_attributes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Custom asset attribute definitions - Get list
 */
export const customAssetAttributesGet = <ThrowOnError extends boolean = true>(options?: Options<CustomAssetAttributesGetData, ThrowOnError>): RequestResult<CustomAssetAttributesGetResponses, CustomAssetAttributesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<CustomAssetAttributesGetResponses, CustomAssetAttributesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: customAssetAttributesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/custom_asset_attributes',
    ...options
});

/**
 * Custom asset attribute definitions - Create
 */
export const customAssetAttributesPost = <ThrowOnError extends boolean = true>(options: Options<CustomAssetAttributesPostData, ThrowOnError>): RequestResult<CustomAssetAttributesPostResponses, CustomAssetAttributesPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<CustomAssetAttributesPostResponses, CustomAssetAttributesPostErrors, ThrowOnError, 'data'>({
    responseTransformer: customAssetAttributesPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/custom_asset_attributes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Custom asset attribute definitions - Rename
 *
 * Only the name (and last_modified_by) can be changed; attribute_type is immutable and any submitted value for it is ignored.
 */
export const customAssetAttributesPut = <ThrowOnError extends boolean = true>(options: Options<CustomAssetAttributesPutData, ThrowOnError>): RequestResult<CustomAssetAttributesPutResponses, CustomAssetAttributesPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<CustomAssetAttributesPutResponses, CustomAssetAttributesPutErrors, ThrowOnError, 'data'>({
    responseTransformer: customAssetAttributesPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/custom_asset_attributes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pcap uploads - Presign
 *
 * Returns a presigned S3 PUT URL the browser can use to upload a pcap file directly to the staging bucket, along with the S3 key it was signed for.
 */
export const pcapUploadsPresignPost = <ThrowOnError extends boolean = true>(options: Options<PcapUploadsPresignPostData, ThrowOnError>): RequestResult<PcapUploadsPresignPostResponses, PcapUploadsPresignPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<PcapUploadsPresignPostResponses, PcapUploadsPresignPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pcap_uploads/presign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pcap uploads - Process
 *
 * Kicks off a Kubernetes Job that runs Zeek/Suricata against an already-uploaded pcap and uploads the resulting logs to the raw bucket. Fire-and-forget: only waits for the Job to be created, not for it to finish.
 */
export const pcapUploadsProcessPost = <ThrowOnError extends boolean = true>(options: Options<PcapUploadsProcessPostData, ThrowOnError>): RequestResult<PcapUploadsProcessPostResponses, PcapUploadsProcessPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<PcapUploadsProcessPostResponses, PcapUploadsProcessPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pcap_uploads/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buildings - Get single
 */
export const buildingsIdGet = <ThrowOnError extends boolean = true>(options: Options<BuildingsIdGetData, ThrowOnError>): RequestResult<BuildingsIdGetResponses, BuildingsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<BuildingsIdGetResponses, BuildingsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: buildingsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/buildings/{id}',
    ...options
});

/**
 * Galvanick appliances - Get list
 */
export const galvanickAppliancesGet = <ThrowOnError extends boolean = true>(options?: Options<GalvanickAppliancesGetData, ThrowOnError>): RequestResult<GalvanickAppliancesGetResponses, GalvanickAppliancesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<GalvanickAppliancesGetResponses, GalvanickAppliancesGetErrors, ThrowOnError, 'data'>({
    responseTransformer: galvanickAppliancesGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances',
    ...options
});

/**
 * Galvanick appliances - Create
 */
export const galvanickAppliancesPost = <ThrowOnError extends boolean = true>(options: Options<GalvanickAppliancesPostData, ThrowOnError>): RequestResult<GalvanickAppliancesPostResponses, GalvanickAppliancesPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<GalvanickAppliancesPostResponses, GalvanickAppliancesPostErrors, ThrowOnError, 'data'>({
    responseTransformer: galvanickAppliancesPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Galvanick appliances - Update
 */
export const galvanickAppliancesPut = <ThrowOnError extends boolean = true>(options: Options<GalvanickAppliancesPutData, ThrowOnError>): RequestResult<GalvanickAppliancesPutResponses, GalvanickAppliancesPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<GalvanickAppliancesPutResponses, GalvanickAppliancesPutErrors, ThrowOnError, 'data'>({
    responseTransformer: galvanickAppliancesPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Galvanick appliances - Get single
 */
export const galvanickAppliancesIdGet = <ThrowOnError extends boolean = true>(options: Options<GalvanickAppliancesIdGetData, ThrowOnError>): RequestResult<GalvanickAppliancesIdGetResponses, GalvanickAppliancesIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<GalvanickAppliancesIdGetResponses, GalvanickAppliancesIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: galvanickAppliancesIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances/{id}',
    ...options
});

/**
 * Endpoint sensors - Get list
 */
export const endpointSensorsGet = <ThrowOnError extends boolean = true>(options?: Options<EndpointSensorsGetData, ThrowOnError>): RequestResult<EndpointSensorsGetResponses, EndpointSensorsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<EndpointSensorsGetResponses, EndpointSensorsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: endpointSensorsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/endpoint_sensors',
    ...options
});

/**
 * Endpoint sensors - Update
 */
export const endpointSensorsPut = <ThrowOnError extends boolean = true>(options: Options<EndpointSensorsPutData, ThrowOnError>): RequestResult<EndpointSensorsPutResponses, EndpointSensorsPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<EndpointSensorsPutResponses, EndpointSensorsPutErrors, ThrowOnError, 'data'>({
    responseTransformer: endpointSensorsPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/endpoint_sensors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Endpoint sensors - Get single
 */
export const endpointSensorsIdGet = <ThrowOnError extends boolean = true>(options: Options<EndpointSensorsIdGetData, ThrowOnError>): RequestResult<EndpointSensorsIdGetResponses, EndpointSensorsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<EndpointSensorsIdGetResponses, EndpointSensorsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: endpointSensorsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/endpoint_sensors/{id}',
    ...options
});

/**
 * Endpoint log sources - Get list
 */
export const endpointLogSourcesGet = <ThrowOnError extends boolean = true>(options?: Options<EndpointLogSourcesGetData, ThrowOnError>): RequestResult<EndpointLogSourcesGetResponses, EndpointLogSourcesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<EndpointLogSourcesGetResponses, EndpointLogSourcesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/endpoint_log_sources',
    ...options
});

/**
 * Endpoint log sources - Set when a channel shows Data missing
 *
 * Applies to every endpoint sensor in the environment. Sets missing_after_hours only; the channel itself is registered by the asset notebooks.
 */
export const endpointLogSourcesPut = <ThrowOnError extends boolean = true>(options: Options<EndpointLogSourcesPutData, ThrowOnError>): RequestResult<EndpointLogSourcesPutResponses, EndpointLogSourcesPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<EndpointLogSourcesPutResponses, EndpointLogSourcesPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/endpoint_log_sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Galvanick appliance-local prefix relationship - Delete
 */
export const galvanickAppliancesLocalPrefixesDelete = <ThrowOnError extends boolean = true>(options?: Options<GalvanickAppliancesLocalPrefixesDeleteData, ThrowOnError>): RequestResult<GalvanickAppliancesLocalPrefixesDeleteResponses, GalvanickAppliancesLocalPrefixesDeleteErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<GalvanickAppliancesLocalPrefixesDeleteResponses, GalvanickAppliancesLocalPrefixesDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances/local_prefixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Galvanick appliance-local prefix relationship - Create new
 */
export const galvanickAppliancesLocalPrefixesPost = <ThrowOnError extends boolean = true>(options?: Options<GalvanickAppliancesLocalPrefixesPostData, ThrowOnError>): RequestResult<GalvanickAppliancesLocalPrefixesPostResponses, GalvanickAppliancesLocalPrefixesPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<GalvanickAppliancesLocalPrefixesPostResponses, GalvanickAppliancesLocalPrefixesPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/galvanick_appliances/local_prefixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Ticket status changes - List
 */
export const ticketStatusChangesGet = <ThrowOnError extends boolean = true>(options?: Options<TicketStatusChangesGetData, ThrowOnError>): RequestResult<TicketStatusChangesGetResponses, TicketStatusChangesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<TicketStatusChangesGetResponses, TicketStatusChangesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/ticket_status_changes',
    ...options
});

/**
 * Ticket comments - Get list
 */
export const ticketsCommentGet = <ThrowOnError extends boolean = true>(options?: Options<TicketsCommentGetData, ThrowOnError>): RequestResult<TicketsCommentGetResponses, TicketsCommentGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<TicketsCommentGetResponses, TicketsCommentGetErrors, ThrowOnError, 'data'>({
    responseTransformer: ticketsCommentGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tickets/comment',
    ...options
});

/**
 * Ticket comments - Add
 *
 * Add comment to ticket
 */
export const ticketsCommentPost = <ThrowOnError extends boolean = true>(options?: Options<TicketsCommentPostData, ThrowOnError>): RequestResult<TicketsCommentPostResponses, TicketsCommentPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<TicketsCommentPostResponses, TicketsCommentPostErrors, ThrowOnError, 'data'>({
    responseTransformer: ticketsCommentPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tickets/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Ticket history - Add
 *
 * Add status history update to ticket
 */
export const ticketsHistoryPost = <ThrowOnError extends boolean = true>(options?: Options<TicketsHistoryPostData, ThrowOnError>): RequestResult<TicketsHistoryPostResponses, TicketsHistoryPostErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<TicketsHistoryPostResponses, TicketsHistoryPostErrors, ThrowOnError, 'data'>({
    responseTransformer: ticketsHistoryPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tickets/history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Users - Get list
 *
 * Every user, with the identity fields and whether the account is enabled. Enough to render a user list showing which accounts still have access; the per-user reads carry organization, roles and group membership, which this deliberately omits.
 *
 * Not confined to the caller's organization — reading users is open to every role, and the manageable flag on the per-user reads is what says whose account the caller may change.
 *
 */
export const usersGet = <ThrowOnError extends boolean = true>(options?: Options<UsersGetData, ThrowOnError>): RequestResult<UsersGetResponses, UsersGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersGetResponses, UsersGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * User - Create with a temporary password
 *
 * Creates a user in one organization, places them in one portal group, and returns the user together with a temporary password to relay. The user must replace that password at their first sign-in; until they do, it gets them no further than the change-password screen.
 *
 */
export const usersPost = <ThrowOnError extends boolean = true>(options: Options<UsersPostData, ThrowOnError>): RequestResult<UsersPostResponses, UsersPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UsersPostResponses, UsersPostErrors, ThrowOnError, 'data'>({
    responseTransformer: usersPostResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * User events - Get list for every user
 *
 * The recent account activity of every user, newest first, as one flat list: sign-ins, credential changes, and changes to the identity an account signs in with. Each event carries the user it happened to, so a client showing activity beside users joins these onto them by user_id. Narrow the read with 'type', 'date_from' and 'date_to'; an omitted filter is not applied. Paged with 'limit' and 'page' like the other lists, and ordered by event date — newest first unless 'order_is_desc' says otherwise. There is no 'order_by': event date is the only ordering the identity provider offers. Covers the last 30 days.
 *
 */
export const usersEventsGet = <ThrowOnError extends boolean = true>(options?: Options<UsersEventsGetData, ThrowOnError>): RequestResult<UsersEventsGetResponses, UsersEventsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersEventsGetResponses, UsersEventsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: usersEventsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/events',
    ...options
});

/**
 * User event types - Get list
 *
 * The event types the event reads report, which is also the set their 'type' filter accepts.
 *
 */
export const usersEventTypesGet = <ThrowOnError extends boolean = true>(options?: Options<UsersEventTypesGetData, ThrowOnError>): RequestResult<UsersEventTypesGetResponses, UsersEventTypesGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersEventTypesGetResponses, UsersEventTypesGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/events/types',
    ...options
});

/**
 * Portal groups - Get assignable list
 *
 * The groups a user may be assigned to, each with the role it grants. Read the assignable set from here rather than hardcoding group names or IDs, which vary between environments.
 *
 */
export const usersGroupsGet = <ThrowOnError extends boolean = true>(options?: Options<UsersGroupsGetData, ThrowOnError>): RequestResult<UsersGroupsGetResponses, UsersGroupsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersGroupsGetResponses, UsersGroupsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/groups',
    ...options
});

/**
 * Organizations - Get list
 *
 * Every organization, without members. Fetch one organization's users from /users/organizations/{id}; this list is deliberately membership-free so a caller that only needs names does not pay for every user. Each entry carries manageable, so where the caller may act is known without fetching each organization.
 *
 */
export const usersOrganizationsGet = <ThrowOnError extends boolean = true>(options?: Options<UsersOrganizationsGetData, ThrowOnError>): RequestResult<UsersOrganizationsGetResponses, UsersOrganizationsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersOrganizationsGetResponses, UsersOrganizationsGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/organizations',
    ...options
});

/**
 * Organization - Get single with its users
 *
 * One organization together with its users. Every organization is readable, so an administrator can see who holds access; each user carries manageable, reporting whether the caller may change them.
 *
 */
export const usersOrganizationsIdGet = <ThrowOnError extends boolean = true>(options: Options<UsersOrganizationsIdGetData, ThrowOnError>): RequestResult<UsersOrganizationsIdGetResponses, UsersOrganizationsIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UsersOrganizationsIdGetResponses, UsersOrganizationsIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: usersOrganizationsIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/organizations/{id}',
    ...options
});

/**
 * User - Get single with account state and portal groups
 *
 * Administrators may read any user, in any organization; every other caller may read only their own record and receives 403 for another user's. Because that limit depends on which user is addressed rather than on the caller's role alone, this operation is annotated as unrestricted. Readable does not imply changeable — check manageable.
 *
 */
export const usersIdGet = <ThrowOnError extends boolean = true>(options: Options<UsersIdGetData, ThrowOnError>): RequestResult<UsersIdGetResponses, UsersIdGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UsersIdGetResponses, UsersIdGetErrors, ThrowOnError, 'data'>({
    responseTransformer: usersIdGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}',
    ...options
});

/**
 * User - Update name or email
 *
 * Changes a user's given name, family name or email. Send only the fields being changed; an omitted field is left as it is, and a body naming no field at all succeeds without changing anything. A field named but sent empty is refused with 400.
 * The response is the user as GET /users/{id} would report them. Group membership, roles, organization and account state are unaffected by this operation.
 *
 */
export const usersIdPatch = <ThrowOnError extends boolean = true>(options: Options<UsersIdPatchData, ThrowOnError>): RequestResult<UsersIdPatchResponses, UsersIdPatchErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<UsersIdPatchResponses, UsersIdPatchErrors, ThrowOnError, 'data'>({
    responseTransformer: usersIdPatchResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * User credentials - Get list for one user
 *
 * One user's credentials: authenticator apps, security keys and recovery codes, but no passwords. Admins may read those of any user in an organization they manage; any other caller only their own. A user outside those answers 404, the same as one that doesn't exist.
 *
 * One flat list across every type; filter or group by type client-side. Empty for a user who holds no credential here, such as one signing in through an identity provider. Whether MFA is on is UserDetail's mfa_enabled; don't derive it from this list.
 *
 * Adding and removing a credential are not API operations: both go through the identity provider's application-initiated actions (CONFIGURE_TOTP, and delete_credential with this list's id), which confirm the action with the user and check the credential is their own.
 *
 */
export const usersIdCredentialsGet = <ThrowOnError extends boolean = true>(options: Options<UsersIdCredentialsGetData, ThrowOnError>): RequestResult<UsersIdCredentialsGetResponses, UsersIdCredentialsGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UsersIdCredentialsGetResponses, UsersIdCredentialsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: usersIdCredentialsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/credentials',
    ...options
});

/**
 * User - Enable or disable portal access
 *
 * Turns a user's portal access on or off. This is how access is taken away instead of deleting the account: a disabled user keeps their identity, so tickets assigned to them, their comments and their history stay attributed and the audit trail stays readable. There is no delete endpoint.
 *
 * Only users with manageable=true may be changed; any other is reported as 404. Idempotent — setting the state a user is already in succeeds unchanged. Refused with 403 when the caller targets themselves, in either direction.
 *
 * **A disable does not revoke access immediately.** Token validation is stateless, so an access token already issued keeps working until it expires — the disable takes the account's sessions with it, which stops the client renewing, but there is no check that rejects the outstanding token. Expect access to end within one access-token lifetime rather than at once, and do not rely on this endpoint alone to cut off a caller who is actively hostile.
 *
 */
export const usersEnabledPut = <ThrowOnError extends boolean = true>(options: Options<UsersEnabledPutData, ThrowOnError>): RequestResult<UsersEnabledPutResponses, UsersEnabledPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UsersEnabledPutResponses, UsersEnabledPutErrors, ThrowOnError, 'data'>({
    responseTransformer: usersEnabledPutResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * User events - Get list for one user
 *
 * One user's recent account activity, newest first: sign-ins, credential changes, and changes to the identity the account signs in with. A last login is the newest event of type LOGIN among them. Takes the same 'type', 'date_from' and 'date_to' filters as GET /users/events. Paged with 'limit' and 'page' like the other lists, and ordered by event date — newest first unless 'order_is_desc' says otherwise. Covers the last 30 days.
 *
 */
export const usersIdEventsGet = <ThrowOnError extends boolean = true>(options: Options<UsersIdEventsGetData, ThrowOnError>): RequestResult<UsersIdEventsGetResponses, UsersIdEventsGetErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UsersIdEventsGetResponses, UsersIdEventsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: usersIdEventsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/events',
    ...options
});

/**
 * User portal group - Remove membership
 *
 * Removes the user from one portal group. Only users with manageable=true may be changed; any other is reported as 404. Idempotent: removing a group the user does not belong to succeeds unchanged. Refused with 403 when the caller targets themselves.
 *
 * The removal takes effect the next time the user's session renews; until then they retain the removed role and are not signed out.
 *
 */
export const usersGroupDelete = <ThrowOnError extends boolean = true>(options: Options<UsersGroupDeleteData, ThrowOnError>): RequestResult<UsersGroupDeleteResponses, UsersGroupDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<UsersGroupDeleteResponses, UsersGroupDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/groups/{group_id}',
    ...options
});

/**
 * User portal group - Add membership
 *
 * Adds the user to one portal group, leaving their other memberships alone. Only users with manageable=true may be changed; any other is reported as 404. Idempotent: adding a group the user already belongs to succeeds unchanged. Membership is not constrained to a single group, so a client moving a user between groups is responsible for removing the old one. The added role takes effect the next time the user's session renews; they are not signed out.
 *
 */
export const usersGroupPut = <ThrowOnError extends boolean = true>(options: Options<UsersGroupPutData, ThrowOnError>): RequestResult<UsersGroupPutResponses, UsersGroupPutErrors, ThrowOnError, 'data'> => (options.client ?? client).put<UsersGroupPutResponses, UsersGroupPutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/groups/{group_id}',
    ...options
});

/**
 * User MFA - Reset by removing every second factor
 *
 * Removes every MFA credential the user holds: authenticator apps, security keys and recovery codes. Their password is kept. Use it for a user who has lost their device; they set up a new second factor through the identity provider.
 *
 * Idempotent: a user holding no MFA credential answers 200 with removed 0, so the action can be offered without first reading mfa_enabled.
 *
 * Refused with 403 for the caller's own account, 404 for a user outside the organizations the caller manages, and 409 for a user whose auth_method is idp, whose identity provider owns their MFA. A failure partway answers 500 with success false and the count already removed; calling again removes the rest.
 *
 */
export const usersIdMfaDelete = <ThrowOnError extends boolean = true>(options: Options<UsersIdMfaDeleteData, ThrowOnError>): RequestResult<UsersIdMfaDeleteResponses, UsersIdMfaDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<UsersIdMfaDeleteResponses, UsersIdMfaDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/mfa',
    ...options
});

/**
 * User password - Reset to a generated temporary one
 *
 * Sets a temporary password on the user and returns it, once. The user must replace it the next time they sign in; until they do, that password gets them no further than the change-password screen. Takes no request body — the password is generated server-side.
 * Not idempotent: each call replaces the password again, invalidating the one the previous call returned. The user's sessions are removed as part of the reset, so they are signed out.
 * Applies only to users whose own auth_method is password, and is refused with 409 otherwise. That is the user's auth_method, not their organization's: a member added directly to an organization that brokers logins still keeps a password here and can be reset. Gating the action on the organization instead would hide it from exactly the local accounts it exists to serve.
 *
 */
export const usersPasswordPost = <ThrowOnError extends boolean = true>(options: Options<UsersPasswordPostData, ThrowOnError>): RequestResult<UsersPasswordPostResponses, UsersPasswordPostErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UsersPasswordPostResponses, UsersPasswordPostErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/password',
    ...options
});

/**
 * Values - Get configured values and settings
 */
export const valuesGet = <ThrowOnError extends boolean = true>(options: Options<ValuesGetData, ThrowOnError>): RequestResult<ValuesGetResponses, unknown, ThrowOnError, 'data'> => (options.client ?? client).get<ValuesGetResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/values',
    ...options
});

/**
 * Suppressions - Get list of active suppression records
 */
export const suppressionsGet = <ThrowOnError extends boolean = true>(options?: Options<SuppressionsGetData, ThrowOnError>): RequestResult<SuppressionsGetResponses, SuppressionsGetErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<SuppressionsGetResponses, SuppressionsGetErrors, ThrowOnError, 'data'>({
    responseTransformer: suppressionsGetResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/suppressions',
    ...options
});

/**
 * Suppressions - Create or update a suppression record
 */
export const suppressionsUpsert = <ThrowOnError extends boolean = true>(options: Options<SuppressionsUpsertData, ThrowOnError>): RequestResult<SuppressionsUpsertResponses, SuppressionsUpsertErrors, ThrowOnError, 'data'> => (options.client ?? client).post<SuppressionsUpsertResponses, SuppressionsUpsertErrors, ThrowOnError, 'data'>({
    responseTransformer: suppressionsUpsertResponseTransformer,
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/suppressions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
